/* Importing the necessary libraries and files */
import { useSelector } from 'react-redux';
import { Link as RouterLink, useParams } from 'react-router-dom';

/* Importing the components from the material-ui library. */
import { Breadcrumbs, Button, Container, Link, Stack, Typography } from '@mui/material';
import { Edit as EditIcon } from '@mui/icons-material/';

/* Importing the components. */
import Page from '../../components/Page';
import DeviceSectionDetails from '../../sections/device/Device.section.details';

/**
 * Renders the device details page.
 * @returns {JSX.Element} The device details page.
 */
export default function DeviceDetails() {
  /* Using the useParams hook to get the params from the URL. */
  const params = useParams();

  const { Devices } = useSelector((state) => state.device);
  const pageDevice = Devices?.find((device) => device.id === params.id);

  return (
    <Page title={`Device Information${pageDevice?.deviceName[0]?.name ? ` - ${pageDevice?.deviceName[0]?.name}` : ''}`}>
      <Container maxWidth="none">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Stack direction="column" justifyContent="space-between">
            <Typography variant="h4" gutterBottom>
              Device Information
            </Typography>
            <Breadcrumbs aria-label="breadcrumb" mr={4}>
              <Link underline="hover" color="inherit" component={RouterLink} to="/device/list">
                Device
              </Link>
              <Typography color="text.primary">{pageDevice?.deviceName[0]?.name || params.id}</Typography>
            </Breadcrumbs>
          </Stack>

          <Button variant="contained" component={RouterLink} to={`/device/edit/${params.id}`} startIcon={<EditIcon />}>
            Edit Device Information
          </Button>
        </Stack>

        <DeviceSectionDetails deviceID={params.id} />
      </Container>
    </Page>
  );
}
